const columns = [
    {
        field: "tmpId",
        type: "tmpId",
        sort: "asc",
        width: 150,
    },
    {
        field: "startDate",
        label: "Od",
        sort: "asc",
        width: 150,
    },
    {
        field: "endDate",
        label: "Do",
        sort: "asc",
        width: 150,
    },
    {
        field: "coefficient",
        label: "Współczynnik",
        sort: "desc",
        width: 80,
    }
];

export default columns;
